import EventListener from './EventListener';

export default new EventListener();
